import Table, { Column } from "../Components/Tables/Table";

import { vieworderdetailslist } from "../Data/testData";

const columns: Column[] = [
  {
    name: "Shipment #",
    selector: (row: { shipment: string }) => row.shipment,
  },
  {
    name: "No.of Lines",
    selector: (row: { noOfLines: string }) => row.noOfLines,
  },
  {
    name: "Shipped Date",
    selector: (row: { shippedDate: string }) => row.shippedDate,
  },
  {
    name: "Shipped Qty",
    selector: (row: { shippedQty: string }) => row.shippedQty,
  },
];
const ViewOrderDetailsModalLayout = () => {
  return (
    <div className="">
      <Table
        customClassName="view-order-modal-table"
        columns={columns}
        data={vieworderdetailslist}
        // handleRowClick={handleRowClick}
        CheckboxStatus={false}
      />
    </div>
  );
};

export default ViewOrderDetailsModalLayout;
